import tippy, {followCursor, hideAll} from 'tippy.js';

import 'tippy.js/dist/tippy.css'; // optional for styling
import {setScroll} from "../Helpers/Scroll";

const selectors = {
    map: '.js--interactive',
    sectorAvailable: '.sector-available > path, .sector-available > polygon, .sector-available > polyline',
    dataTemplate: 'data-template'
};

class InteractiveMap {

    constructor() {
        this.map = document.querySelector(selectors.map);

        if (!this.map) {
            return;
        }

        this.tooltipMap();
        this.statusPlot();
        setScroll(this.map);
    }

    tooltipMap() {

        /* fix for correct display tooltip on SVG */
        const targetNode = document.getElementById("svg");
        const config = {attributes: true, childList: true, subtree: true};
        const callback = function (mutationsList, observer) {
            for (let mutation of mutationsList) {
                if (mutation.type === 'childList') {
                    for (let addedNode of mutation.addedNodes) {
                        if (addedNode.hasAttribute("data-tippy-root")) {
                            refreshFsLightbox();
                            document.body.appendChild(addedNode);
                        }
                    }
                }
            }
        };

        const observer = new MutationObserver(callback);
        observer.observe(targetNode, config);

        const instanceAvailable = tippy('.sector-available > path, .sector-available > polygon, .sector-available > polyline', {
            content(reference) {
                const id = reference.getAttribute('data-template');
                const template = document.getElementById(id);
                if (!template) {
                   return;
                }
                return template.innerHTML;
            },
            allowHTML: true,
            interactive: true,
            placement: 'right',
            hideOnClick: false,
            interactiveBorder: 40,
            delay: 400,
            popperOptions: {
                modifiers: [
                    {
                        name: 'preventOverflow',
                        options: {
                            altAxis: true,
                            tether: false,
                        },
                    },
                ],
            },
            onShow() {
                hideAll({exclude: instanceAvailable});
            }
        });


        const instanceNoAvailable = tippy('.sector-noavailable', {
            content(reference) {
                const id = reference.getAttribute('data-template');
                const template = document.getElementById(id);
                if (!template) {
                    return;
                }
                return template.innerHTML;
            },
            allowHTML: true,
            interactive: true,
            placement: 'right-start',
            hideOnClick: false,
            followCursor: 'initial',
            delay: '100',
            plugins: [followCursor],
            onShow() {
                hideAll({exclude: instanceNoAvailable});
            },
        });
    }


    /* set status path svg by class (available / reservation / no-available) */
    statusPlot() {
        const sector = document.querySelectorAll(selectors.sectorAvailable);

        if (sector.length === 0) {
            return;
        }

        for (let i = 0; sector.length > i; i++) {
            const sectorID = sector[i].getAttribute(selectors.dataTemplate);
            const tooltipID = document.getElementById(sectorID);

            if (tooltipID) {
                const status = tooltipID.getAttribute('data-status');
                sector[i].classList.add(status);
            }
        }
    }

}

export default InteractiveMap;
